<div class="mat-sidenav"
              [ngClass]="(sidenavExpanse | async) ? 'sidenav-aberto' : 'sidenav-fechado'">
  <div class="sidenav-base">
    <ng-container *ngIf="(sidenavExpanse | async)">
    </ng-container>

    <ng-container>
      <mat-list [style.width]="'100%'" [style.flex]="'1'" [style.overflow-y]="'auto'" [style.overflow-x]="'visible'">

        <div class="menu-container">
          <div class="menu-start">
            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(GRID_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/grid')"
              (click)="irParaUrl('/grid')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="controle" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="controle" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.CONTROL_TOWER' | translate }}</span>
              </span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(MAPA_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/mapa')"
              (click)="irParaUrl('/mapa')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="maps" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="maps" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.MAP' | translate }}</span>
              </span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(ADMIN_VISITAS_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/administrar-visitas')"
              (click)="irParaUrl('/administrar-visitas')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="visitas" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="visitas" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.VISITS_MANAGEMENT' | translate }}</span>
              </span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(REPROGRAMACAO, roles | async) && ativaReprogramacao"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/reprogramacao')"
              (click)="irParaUrl('/reprogramacao')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="reprograme" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="reprograme" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.REPROGRAMACAO' | translate }}</span>
              </span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(DASHBOARD_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/dashboard')"
              (click)="irParaUrl('/dashboard')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="painel" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon svgIcon="painel" class="mr-5" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.DASHBOARD' | translate }}</span>
              </span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(ADMIN_CARREGAMENTO_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/administrar-carregamento')"
              (click)="irParaUrl('/administrar-carregamento')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" *ngIf="(sidenavExpanse | async) === false">pending_actions</mat-icon>
                <mat-icon class="mr-5" *ngIf="(sidenavExpanse | async)">pending_actions</mat-icon>
                <span *ngIf="(sidenavExpanse | async)">Carregamentos</span>
              </span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(FINANCEIRO_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/financeiro')"
              (click)="irParaUrl('/financeiro')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" svgIcon="dollar_note" *ngIf="(sidenavExpanse | async) === false"></mat-icon>
                <mat-icon class="mr-5" svgIcon="dollar_note" *ngIf="(sidenavExpanse | async)"></mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.FINANCIAL' | translate }}</span>
              </span>
            </a>

            <a mat-list-item *ngIf="false"
              [disabled]="true">
              <mat-icon class="mr-5"></mat-icon>
              <span>{{ 'SHARED.TERMS.SITUATION_ROOM' | translate }}</span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(RELATORIOS_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/relatorios')"
              (click)="irParaUrl('/relatorios')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" fontSet="material-icons-outlined" *ngIf="(sidenavExpanse | async) === false">analytics</mat-icon>
                <mat-icon class="mr-5" fontSet="material-icons-outlined" *ngIf="(sidenavExpanse | async)">analytics</mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.REPORTS' | translate }}</span>
              </span>
            </a>

            <a mat-list-item class="menu-item"
              *ngIf="checkRoles(ALERTAS_INCIDENTES_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/alertas')"
              (click)="irParaUrl('/alertas')"  >
              <span class="vertical-wrapper">
                <lucide-icon class="icon_off" [matBadge]="alertesPadding > 0 ? alertesPadding : null" matBadgeColor="warn" name="triangle-alert" size="18" *ngIf="(sidenavExpanse | async) === false"></lucide-icon>
                <lucide-icon [matBadge]="alertesPadding > 0 ? alertesPadding : null" matBadgeColor="warn" name="triangle-alert" size="18" class="mr-2" *ngIf="(sidenavExpanse | async) === true"></lucide-icon>
                <span *ngIf="(sidenavExpanse | async)" class="menu-text-alerts">
                  {{ 'SHARED.TERMS.ALERTS_INCIDENTS' | translate }}
                </span>
              </span>
            </a>

              <!-- *ngIf="showTalkJs && checkRoles(TALKS_PATH, roles | async)" -->
            <a mat-list-item class="menu-item"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/talks')"
              (click)="irParaUrl('/talks')">
              <span class="vertical-wrapper">
                <!-- <mat-icon class="icon_off" *ngIf="(sidenavExpanse | async) === false">chat</mat-icon>
                <mat-icon class="mr-3" *ngIf="(sidenavExpanse | async)">chat</mat-icon> -->
                <lucide-icon class="icon_off" [matBadge]="talkJsUnreadCount > 0 ? talkJsUnreadCount : null" matBadgeColor="primary" name="message-square-text" size="18" *ngIf="(sidenavExpanse | async) === false"></lucide-icon>
                <lucide-icon [matBadge]="talkJsUnreadCount > 0 ? talkJsUnreadCount : null" matBadgeColor="primary" name="message-square-text" size="18" class="mr-2" *ngIf="(sidenavExpanse | async) === true"></lucide-icon>
                <span *ngIf="(sidenavExpanse | async)">Chat</span>
              </span>
            </a>

            <!-- <a mat-list-item class="menu-item"
              *ngIf="showChat && checkRoles(CHAT_PATH, roles | async)"
              [class.menu-selected]="(menuOpened | async)?.startsWith('/chat')"
              (click)="irParaUrl('/chat')">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" *ngIf="(sidenavExpanse | async) === false">chat</mat-icon>
                <mat-icon class="mr-3" *ngIf="(sidenavExpanse | async)">chat</mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.CHAT' | translate }}</span>
              </span>
            </a> -->

            <a mat-list-item *ngIf="false"
              [disabled]="true">
              <mat-icon class="mr-3">help</mat-icon>
              <span>{{ 'SHARED.TERMS.HELP' | translate }}</span>
            </a>
          </div>
          <div class="menu-end">
            <a mat-list-item class="menu-item" *ngIf="hasLogoutRedirect" (click)="logoutRedirect()">
              <span class="vertical-wrapper">
                <mat-icon class="icon_off" *ngIf="(sidenavExpanse | async) === false">logout</mat-icon>
                <mat-icon class="mr-3" *ngIf="(sidenavExpanse | async)">logout</mat-icon>
                <span *ngIf="(sidenavExpanse | async)">{{ 'SHARED.TERMS.RETURN_TO_ROUTER' | translate }}</span>
              </span>
            </a>
          </div>
        </div>

      </mat-list>

    </ng-container>

    <!-- Seção de Versão - FORA do ng-container para ficar no sidenav-base -->
    <div class="version">
      <!-- Versão fechada - só mostra o ícone -->
      <div *ngIf="(sidenavExpanse | async) === false" class="version-icon">
        <mat-icon svgIcon="infinito"></mat-icon>
      </div>

      <!-- Versão aberta - mostra informações completas -->
      <div *ngIf="(sidenavExpanse | async) === true" class="version-expanded">
        <div class="version-title">{{ descriptionState | async }}</div>
        <div class="version-row">
          <div class="version-brand">
            <span class="version-powered-by">POWERED BY</span>
            <span
              class="version-logo-img"
              role="img"
              aria-label="Mobiis"
              (click)="irParaUrl('/')"
              (keydown)="irParaUrl('/')"
              tabindex="0"
            ></span>
          </div>
          <span class="version-number">v {{ versaoState | async }}</span>
        </div>
      </div>
    </div>

  </div>
</div>
